import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from'../Component/Header'
const SchoolHours = () => { 
    useEffect(() => {
        document.title = ' School Hours - Sacread Heart Kharagpur';  
    }, []); 
  return (
     <>
     <Header/>
       <div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li>  Academic</li>
                 <li>School Hours</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1>School Hours</h1>
                    </div>
                </div>
                <div className="row">
                     <div className="col-lg-8 col-12 mx-auto d-block maintable">
                     <table class="table" cellspacing="0" border="0">
                     <tbody>
                     <tr> <th colspan="2">Class</th> </tr> 
                     <tr> <td width="100px">Class V-XII </td> <td width="50px"> <b>7.30 A.M to 1.15 P.M</b></td> </tr> 
                     <tr> <td width="100px">Tiffin Break </td> <td width="50px"><b>10.45 A.M to 11.15 A.M </b></td> </tr> 
                     <tr>
                     <th colspan="2">Assembly</th> </tr>
                      <tr><td colspan="2">On Mondays and Wednesday Assembly will be held.  <br/>
                     Assembly Begins 10 Mins before the class hours i.e.,
                     at 7.35 A.M. Attendance at assembly is compulsory</td></tr> 
                     </tbody>
                     </table>
                  </div>
                </div>
            </div>
        </div>
     </>
  )
}

export default SchoolHours

